import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuctionRoutingModule } from './auction-routing.module';
import { ngfModule } from 'angular-file';
import { AuctionListComponent } from './auction-list/auction-list.component';
import { AddAuctionComponent } from './add-auction/add-auction.component';
import { AdminSharedModule } from '../shared/shared.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { AddAuctionStep2Component } from './add-auction-step2/add-auction-step2.component';
import { AddAuctionStep3Component } from './add-auction-step3/add-auction-step3.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AddAuctionStep4Component } from './add-auction-step4/add-auction-step4.component';
import { MatChipsModule } from '@angular/material/chips';
import { AddAuctionStep1Component } from './add-auction-step1/add-auction-step1.component';
import { CommonSharedModule } from '../../shared/shared.module';
import { ViewAuctionComponent } from './view-auction/view-auction.component';
import { ManageLotModule } from './manage-lot/manage-lot.module';
import { AuctionResultComponent } from './auction-result/auction-result.component';
import { ImportedUsersComponent } from './imported-users/imported-users.component';
import { ImportResultComponent } from './import-result/import-result.component';
import { ImportResultService } from './service/import-result.service';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    AuctionListComponent,
    AddAuctionComponent,
    AddAuctionStep2Component,
    AddAuctionStep3Component,
    AddAuctionStep4Component,
    AddAuctionStep1Component,
    ViewAuctionComponent,
    AuctionResultComponent,
    ImportedUsersComponent,
    ImportResultComponent,
  ],
  imports: [
    CommonModule,
    AuctionRoutingModule,
    CommonSharedModule,
    AdminSharedModule,
    MatDialogModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaterialTimepickerModule,
    ngfModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    ManageLotModule,
    MatTableModule,
    MatTooltipModule,
  ],
  providers: [ImportResultService],
})
export class AuctionModule {}
